<template>
  <Breadcrumbs
      title="Dealer Groups"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Dealer Groups', path: '/dealer-groups' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <dealerGroupsList/>
    </div>
  </div>
</template>

<script>

import dealerGroupsList from "@/pages/master_data/dealer_groups/dealerGroupsList.vue";

export default {
  components: {
    dealerGroupsList
  }
}
</script>